import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {cloneDeep} from 'lodash';
import {
    CANDIDATE_CATEGORY_FIELDS,
    LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ORDER_BY, ResponseCode
} from "@app/constants/Common";
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem, arrayToString} from "@app/utils/CommonUtils";
import {requestCandidates} from "@app/services/CandidateService";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import {requestStartRunJob} from "@app/services/JobService";
import {
    requestAddCddToFollowUpTabDVTJCUV,
    requestCheckFollowUpDVTJCUV,
    requestStartRunDVTJCUV
} from "@pages/dvtjcuv/service/DVTJCUVService";
import {toast} from "react-toastify";
import DVTJCUVPipelineTableList, {DVTJCUVPipelineListMode} from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVNextFollowUpPlan from "@pages/candidate/list/DVTJCUVNextFollowUpPlan";
import {alertMessage, showMessage} from "@app/constants/Messages";
import {
    requestDeleteExcludeReceiverIds,
    requestGetExcludeReceiverIds,
    requestSaveExcludeReceiverIds
} from "@pages/dvtjcuv/service/DVTJCUVSearchCddJobService";
import fa from "suneditor/src/lang/fa";


const DVTJCUVSearchJobExcludeReceiverModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep({}));
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [inputIds, setInputIds] = useState('');
    const [notes, setNotes] = useState('');
    const [isProcessing, setProcessing] = useState(false);


    const {cddId, isShow, onClose} = props

    const fetchCandidates = async (canIds) => {
        const params = {
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: searchConditions
        }
        params.search_conditions.candidate_ids = canIds
        params.search_conditions.search_cdd_job_exclude_receiver_mode = true
        params.search_conditions.cdd_id = cddId


        const res = await requestCandidates(params);

        setCandidates(res.content.candidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
    }

    const fetchExcludeReceivers = async () => {
        const params = {
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: searchConditions
        }
        params.cdd_id = cddId

        const res = await requestGetExcludeReceiverIds(params);
        if (res.sts_code === ResponseCode.SUCCESS) {
            const recIds = res.content;
            if (recIds.length > 0) {
                fetchCandidates(recIds)
            } else {
                setCandidates([])
            }
        } else {
            alertMessage(res.sts_code)
        }
    }

    useEffect(() => {
        if (cddId) {
            fetchExcludeReceivers()
        }
    }, [cddId]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }

    },[])

    const onAddExcludeReceiverIds = () => {
        const recIds = inputIds.split(' ')
        const request = {cdd_id: cddId, notes: notes}
        request.receiver_ids = recIds.map(item => item.trim()).filter(item => !!item);
        requestSaveExcludeReceiverIds(request).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                const notExistsRecIds = res.content.not_exist_rec_ids
                const successRecIds = res.content.success_rec_ids
                showMessage(
                    `Số receiver Ids lưu thành công: ${successRecIds.length} ${notExistsRecIds.length ? '\nReceiverIds lưu thất bại: ' + arrayToString(notExistsRecIds) : ''}`)
                fetchExcludeReceivers()
            } else {
                showMessage(res.message, true, true)
            }
        })
    }

    const onDeleteExcludeReceiverIds = (ids) => {
        if (!ids || ids.length === 0) {
            showMessage('Vui lòng chọn receiver id')
            return;
        }

        if (window.confirm("Bạn chắc chắn muốn xóa receivers này?") === true) {
            const request = {cdd_id: cddId, notes: notes}
            request.receiver_ids = ids;
            requestDeleteExcludeReceiverIds(request).then(res => {
                if (res.sts_code === ResponseCode.SUCCESS) {
                    fetchExcludeReceivers()
                } else {
                    showMessage(res.message, true, true)
                }
            })
        }
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen style={{zIndex: 3002}}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Loại trừ Receivers</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{overflowY: 'auto'}}>
                    <div className={'card card-default'}>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Danh sách receivers</h3>
                            <div className={'card-tools'} style={{width:'50%'}}>
                                <label>Thêm receiver Ids:</label>
                                <div className={'row'}>
                                    <input
                                        className={'form-control mr-1 col-sm-5'}
                                        type='text'
                                        value={inputIds}
                                        onChange={(event) => {
                                            const values = event.target.value
                                            if (!values || /^[0-9\s]*$/.test(values)) {
                                                setInputIds(values);
                                            }
                                        }}
                                        placeholder={'Nhập receiver Id cách nhau bởi dấu cách. Ví dụ: 1 2 3'}
                                    />
                                    <input className={'form-control mr-1 col-sm-5'}
                                           type='text'
                                           value={notes}
                                           onChange={(event) => setNotes(event.target.value)}
                                           placeholder={'Notes'}
                                    />
                                    <button type='button'
                                            className='btn btn-info btn-sm float-right'
                                            disabled={inputIds.length === 0 || isProcessing}
                                            onClick={onAddExcludeReceiverIds}>
                                        { isProcessing ? 'Processing...' : 'Add Receivers' }
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='card-body'>
                            <CandidateListTable
                                showBtnSelect
                                candidates={candidates}
                                allCandidateIds={allCandidateIds}
                                mode={CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS}
                                totalCount={totalCount}
                                onDelete={onDeleteExcludeReceiverIds}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DVTJCUVSearchJobExcludeReceiverModal;
